export class ApiCredentials {
    'clientId';
    'clientSecret';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "clientId",
            "baseName": "clientId",
            "type": "string",
            "format": ""
        },
        {
            "name": "clientSecret",
            "baseName": "clientSecret",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ApiCredentials.attributeTypeMap;
    }
    constructor() {
    }
}
